<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active"><a href="#">Product</a></li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="message" class="alert-danger alert visibility" role="alert">
            {{ message }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <form @submit.prevent="submitForm">
            <div class="row">
                  <legend>Add Product:</legend>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>KS Part Number *</label>
                      <input
                        v-model="product.ProductName"
                        v-validate="'required'"
                        type="text"
                        placeholder="KS Part Number"
                        class="form-control"
                        name="PartNumber"
                      />
                      <span v-if="errors.has('PartNumber')">
                        {{ errors.first('PartNumber') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Project *</label>
                      <input
                        v-model="product.Project"
                        v-validate="'required'"
                        type="text"
                        placeholder="Project"
                        class="form-control"
                        name="Project"
                      />
                      <span v-if="errors.has('Project')">
                        {{ errors.first('Project') }}
                      </span>
                    </div>
                  </div>
                  
            </div>
               <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Application *</label>
                      <input
                        v-model="product.Application"
                        v-validate="'required'"
                        type="text"
                        placeholder="Application"
                        class="form-control"
                        name="Application"
                      />
                      <span v-if="errors.has('Application')">
                        {{ errors.first('Application') }}
                      </span>
                    </div>
                  </div>
                   <div class="col-md-3">
                    <div class="form-group">
                      <label> Point Per Unit </label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="PointPerUnit"
                        v-model="product.PointPerUnit"
                        min="1"
                        step="1"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                        <div class="form-group">
                          <label>Segment</label>
                          <v-select
                            v-model="product.Segment"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsSegment"
                          ></v-select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                          <label>ProductType</label>
                          <v-select
                            v-model="product.ProductType"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsProductType"
                          ></v-select>
                        </div>
                    </div>
                    
                   
               </div>
               <div class="row">
                 <div class="col-md-9">
                    <div class="form-group">
                    <label>Product Description</label>
                    <textarea placeholder="Product Description" class="form-control" :multiline="true" v-model="product.Descriptions"></textarea>
                    </div>
              </div>
               </div>
                  
            <div class="row">
              <div class="col-sm-3 col-sm-offset-9">
                        <div class="form-group">
                          <button
                            class="btn-raised btn-primary btn fixcolorAs"
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Submit</span>
                          </button>
                        </div>
                  </div>
            </div>           
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import chield from './components/child';
import UserService from '../services/user.service';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import ModelSelectEnquery from './components/ModelSelectEnquery'
import VeeValidate from 'vee-validate';
const phoneRule = {
  getMessage(field, args) {
    return `The ${field} must be either a valid phone number`;
  },
  validate(value, args) {
    
    const MOBILEREG = /^(0|[+91]{3})?[7-9][0-9]{9}$/;
    
    // Check for either of these to return true
    return MOBILEREG.test(value);
  }
};

// Extend VeeValidate with our new custom rule
VeeValidate.Validator.extend('phone', phoneRule);

function initialState() {
  return {
        ProductType: '',
        ProductName: '',
        Descriptions: '',
        Project: '',
        Application:'',
        Segment:'',
        PointPerUnit:'0'
      }
}
export default {
  name: 'addProduct',
  data() {
    return {
      loading:false,
      isReadOnly:true,
      message: '',
      SuccessMessage:'',
      optionsSegment:[
          { value: null, text: 'Please Select Segment Type'},
          { value: 'Agriculture', text: 'Agriculture'},
           { value: 'Industrial', text: 'Industrial'},
            { value: 'LCV', text: 'LCV'},
            { value: 'M/HCV', text: 'M/HCV'},
            { value: 'Micro-LCV', text: 'Micro-LCV'},
            { value: 'PC Diesel', text: 'PC Diesel'},
            { value: 'PC Gasoline', text: 'PC Gasoline'},
            { value: 'Tractor', text: 'Tractor'}
          
      ],
      optionsProductType:[
         { value: null, text: 'Please Select Product Type'},
        { value: 'Bearing', text: 'Bearing' },
        { value: 'Bush', text: 'Bush' },
        { value: 'Thrust Washer', text: 'Thrust Washer'},
        { value: 'Engine Valve', text: 'Engine Valve'}
      ],
      product: initialState(),
    };
  },
  components: { vSelect,ModelSelectEnquery},
  computed: {
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    selectedOptionArrayFunction(val){
      this.product.modelName =""
      this.product.Quantity="00"
      if(typeof(val) !== 'undefined' && val !== null ){
        this.errors.remove('ModelNumber');
        this.product.modelName = val.ModelName
        this.product.Quantity = val.Quantity
      }
      if (this.product.modelName == '') {
          this.errors.add({
            field: 'ModelNumber',
            msg: 'Please Select Model Number',
          });
        }
    },

    submitForm() {
      this.$validator.validateAll().then((res) => {
         if (this.product.modelName == '') {
          this.errors.add({
            field: 'ModelNumber',
            msg: 'Please Select Model Number',
          });
          res = false;
        }
        if (!res) {
          // handle input errors.
          this.message = 'Please Fill all menditory Options';
            setTimeout(() => (this.message = false), 5000);
          return;
        }
        if (res) {
          UserService.postMetod(
            'kspgAPI/Product/add',
            this.product
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        } else {
          this.message = 'Please correct all error!';
        }
      });
    },
    resetWindow: function () {
      Object.assign(this.$data.product, initialState());
    },
  } 
};
</script>
<style>
.visibility {
  visibility:visible !important;
}

</style>